module.exports = __webpack_public_path__ + "static/media/tips-offset.f42e4554.png";